/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';

import type { JSX } from '@ovhcloud/ods-stencil/components/pagination/custom-elements';

import { defineCustomElement as defineOsdsPagination } from '@ovhcloud/ods-stencil/components/pagination/custom-elements/osds-pagination.js';

export const OsdsPagination = /*@__PURE__*/createReactComponent<JSX.OsdsPagination, HTMLOsdsPaginationElement>('osds-pagination', undefined, undefined, defineOsdsPagination);
